import {CmsBannerComponent, CmsBannerComponentProps} from "../cms-banner/cms-banner.component";
import {AdminBannerComponent, AdminBannerComponentProps} from "../admin-banner/admin-banner.component";
import * as React from "react";
import {observer} from "mobx-react";
import {ComponentServicesPick} from "../../services/component-services-pick";
import {withServices} from "../../react-hooks/with-services";

export interface BannerComponentProps extends  CmsBannerComponentProps, AdminBannerComponentProps {

}
interface BannerComponentWithServicesProps extends ComponentServicesPick<'adminBanner'>, BannerComponentProps {
}

const ComponentBody: React.FC<BannerComponentWithServicesProps> = observer((props) => {
    if(props.adminBanner.adminBannerEnabled) {
        return (<AdminBannerComponent {...(props as AdminBannerComponentProps)}/>);
    } else {
        return (<CmsBannerComponent {...(props as CmsBannerComponentProps)}/>)
    }
});


export const BannerComponent = withServices(ComponentBody, ["adminBanner"]);